import { useState, TouchEvent, useEffect } from 'react';

export const HANDLE_WIDTH = 56;

interface Props {
    containerWidth: number;
    onConfirm?: () =>void;
}

function useSlideHandle({ containerWidth, onConfirm }:Props) {
    const [translateX, setTranslateX] = useState<number>(0);
    const [startX, setStartX] = useState<number>(0);
    const [isMoveEnd, setIsMoveEnd] = useState<boolean>(false);
    const percent = translateX / (containerWidth);
    const handleTouchStart = (e: TouchEvent<HTMLDivElement>) => {
        const { clientX } = e.touches[0];
        setStartX(clientX);
        setIsMoveEnd(false);
    };
    const handleTouchMove = (e: TouchEvent<HTMLDivElement>) => {
        const { clientX } = e.touches[0];
        const newValue = clientX - startX;
        if (newValue >= 0 && newValue < containerWidth - HANDLE_WIDTH) {
            setTranslateX(newValue);
        }
    };

    const handleTouchEnd = () => {
        setIsMoveEnd(true);
        if (percent > 0.8) {
            setTranslateX(containerWidth - HANDLE_WIDTH);
            onConfirm?.();
            const resetTimeout = setTimeout(() => {
                setTranslateX(0);
            }, 1000);
            return () => clearTimeout(resetTimeout);
        }
        setTranslateX(0);
        return () => {};
    };
    return {
        percent,
        handleTouchStart,
        handleTouchMove,
        handleTouchEnd,
        isMoveEnd,
        translateX,
    };
}

export default useSlideHandle;
